import React from "react";
import { exit_icon } from "../../../icons/exit";
import { delete_icon } from "../../../icons/trash";
import Client from "../../../utils/client";
import { api_url } from "../../../constant";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const DeleteModal = ({ setShowDetails, item, refetch }) => {
  const sold = async () => {
    if (item.service) {
      await Client.post(
        api_url + `/services/edit/${item.id}`,
        JSON.stringify({ status: "sold" }),
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
        .then(refetch)
        .catch((e) => toast("الرجاء التأكد من البيانات", { type: "error" }));
    } else if (item.input_category) {
      await Client.post(
        api_url + `/inputs/edit/${item.id}`,
        JSON.stringify({ status: "sold" }),
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
        .then(refetch)
        .catch((e) => toast("الرجاء التأكد من البيانات", { type: "error" }));
    } else {
      await Client.post(
        api_url + `/offers/edit/${item.id}`,
        JSON.stringify({ status: "sold" }),
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
        .then(refetch)
        .catch((e) => toast("الرجاء التأكد من البيانات", { type: "error" }));
    }
  };
  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
        <div className="relative mx-5 max-w-3xl lg:w-[500px] lg:mx-auto my-6">
          <div className="relative  flex flex-col w-full bg-white border-[3px] border-primary rounded-3xl shadow-lg outline-none focus:outline-none  p-3">
            <div className="mx-auto">
              <p className="font-medium text-center my-6">
                هل انت متأكد من أن المدخل المختار تم بيعه وتريد حذفه من قائمة
                العروض ؟
              </p>
              <div className="flex justify-center gap-4 my-4">
                <button
                  onClick={() => {
                    setShowDetails(false);
                  }}
                  className="border-primary rounded-[13px] border px-[38.5px] py-2 "
                >
                  خروج
                </button>
                <button
                  onClick={() => {
                    setShowDetails(false);
                    sold();
                  }}
                  className="  text-white gap-1 bg-[#C80C00] rounded-[13px] flex  px-7 py-2 "
                >
                  حذف
                  <span className="">
                    <svg
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.5 5.48332C14.725 5.20832 11.9333 5.06665 9.15 5.06665C7.5 5.06665 5.85 5.14998 4.2 5.31665L2.5 5.48332"
                        stroke="white"
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.08203 4.6415L7.26536 3.54984C7.3987 2.75817 7.4987 2.1665 8.90703 2.1665H11.0904C12.4987 2.1665 12.607 2.7915 12.732 3.55817L12.9154 4.6415"
                        stroke="white"
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M15.7077 8.1167L15.166 16.5084C15.0744 17.8167 14.9993 18.8334 12.6743 18.8334H7.32435C4.99935 18.8334 4.92435 17.8167 4.83268 16.5084L4.29102 8.1167"
                        stroke="white"
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8.60938 14.25H11.3844"
                        stroke="white"
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.91797 10.9165H12.0846"
                        stroke="white"
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="fixed inset-0 z-40 bg-black opacity-25"
        onClick={() => {
          setShowDetails(false);
        }}
      ></div>
    </>
  );
};

export default DeleteModal;
